import type { ReactNode } from 'react';
import { SectionHeader } from '../../../components/SectionHeader';

/**
 * The Interviews section's header (Redesign Group 7): Calendar · To schedule · My interviews ·
 * My availability, from the module bar's own pages — so a panelist, who holds no interview plan
 * (§L23 Job config), never gets To schedule. The mockups draw no line under the title.
 */

export type InterviewsPage = 'calendar' | 'to_schedule' | 'mine' | 'availability';

const PAGE_PATHS: Readonly<Record<InterviewsPage, string>> = {
  calendar: '/interviews',
  to_schedule: '/interviews/to-schedule',
  mine: '/interviews/mine',
  availability: '/interviews/availability',
};

export function InterviewsHeader({ current }: { readonly current: InterviewsPage }): ReactNode {
  return <SectionHeader moduleId="interviews" title="Interviews" current={PAGE_PATHS[current]} />;
}
